import AdminHttpClient from './AdminHttpService';

function getMrr() {
    return AdminHttpClient.get('/stripe/mrr');
}

function listCoupons() {
    return AdminHttpClient.get('/stripe/coupons');
}

function getCoupon(couponId) {
    return AdminHttpClient.get(`/stripe/coupons/${couponId}`);
}

function createCoupon(payload) {
    return AdminHttpClient.post('/stripe/coupons', payload);
}

function updateCouponName(couponId, payload) {
    return AdminHttpClient.patch(`/stripe/coupons/${couponId}`, payload);
}

function createPromotionCode(couponId, payload) {
    return AdminHttpClient.post(`/stripe/coupons/${couponId}/promotion-codes`, payload);
}

function deactivatePromotionCode(couponId, promotionCodeId) {
    return AdminHttpClient.delete(`/stripe/coupons/${couponId}/promotion-codes/${promotionCodeId}`);
}

function deleteCoupon(couponId) {
    return AdminHttpClient.delete(`/stripe/coupons/${couponId}`);
}

export default {
    getMrr,
    listCoupons,
    getCoupon,
    createCoupon,
    updateCouponName,
    createPromotionCode,
    deactivatePromotionCode,
    deleteCoupon
};
